module.exports = __webpack_public_path__ + "static/img/c8m-loading.de0aaeac.png";